import * as React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  footerStyle,
  footerNavList,
  socialLink
} from "./footer.module.css"
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons"

export function FooterLite() {
  return (
    <footer className={footerStyle}>
      <nav aria-label="footer">
        <ul className={footerNavList}>
          <li>
            <span>
              <a className={socialLink} href="https://facebook.com/hoopsandcrossesuk" title="Hoops & Crosses on Facebook">
                <FontAwesomeIcon size="lg" icon={faFacebook}></FontAwesomeIcon>
              </a>
              <a className={socialLink} href="https://instagram.com/hoopsandcrossesuk" title="Hoops & Crosses on Instagram">
                <FontAwesomeIcon size="lg" icon={faInstagram}></FontAwesomeIcon>
              </a>
            </span>
          </li>
        </ul>
      </nav>
    </footer>
  )
}
